export default __webpack_public_path__ + "static/media/close-light.fbc17b97.svg";